import { useState } from "react";

export function useReminderTabContent() {
  const [isPastRemindersOpened, setIsPastRemindersOpened] = useState<boolean>(false);

  return {
    isPastRemindersOpened,
    handleTogglePastReminders: () => setIsPastRemindersOpened((isOpened) => !isOpened),
  };
}
